<div *ngIf="auth.authenticated && auth?.user?.deactivatedNumbersAccess;else other_content;">
  <h2>Deactivated Numbers</h2>
  <br />
  <p *ngIf="!allApplications"><em>Loading...</em></p>
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-overlay-content">
      <div class="spinner"></div>
      <span>Please Wait...</span>
    </div>
  </div>

  <div *ngIf="allApplications" class="applications">
    <table class='table'>
      <thead>
        <tr>
          <th style="text-align: center">Order</th>
          <th style="text-align: center">Account Number</th>
          <th style="text-align: center">Worked?</th>
          <th style="text-align: center">Phone Number</th>
          <th style="text-align: center">Contact Result?</th>   
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let application of allApplications; let isOdd=odd; let i=index;">
          <tr [class.odd]="isOdd">
            <td style="text-align: center">
              <span>{{ i + 1 }}</span>
            </td>
            <td style="text-align: center">
              <button type="button" class="btn btn-default" (click)='attemptsButtonResponse(application, i, true)'>{{ application.accountNumber }}</button>
            </td>
            <td style="text-align: center">
              <span>{{ application.worked ? "Yes" : "No" }}</span>
            </td>
            <td style="text-align: center">
              {{ application.phoneNumber }}
            </td>
            <td style="text-align: center">
              <button type="button" class=" btn btn-success" id="Active" (click)='updateActive(application)'>Customer</button>
              <button type="button" class=" btn btn-success" id="Inactive" (click)='updateInactive(application)'>Not Customer</button>
              <button type="button" class=" btn btn-info" id="Unsure" (click)='attemptsButtonResponse(application, i, false)'>Unsure</button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<ng-template #other_content>
  <div *ngIf="!auth.authenticated; else unauthorized;">
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />

    <div class="numbers">
      <h1>Please <a (click)="auth.signIn()" [routerLink]="">sign in</a> to continue.</h1>
    </div>

    <br />
    <br />
    <br />
    <br />

    <div class="numbers">
      <img class="logo" src="assets/CollectorAssistantToolLogoNavy.png" />
    </div>

  </div>
  <ng-template #unauthorized>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <h2 class="notAuth">You are not authorized to view this page. Please contact your manager.</h2>
  </ng-template>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/deactivated-numbers/deactivated-numbers.component.html